import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class ContribuicoesProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;

  constructor(public http: HttpClient) {}

  getContasBancarias() {
    return this.http.get<any>(this.baseUrl + '/contribuicao/get-contas-bancarias').map((data) => {
      return data;
    });
  }

  getConfigs() {
    return this.http.get<any>(this.baseUrl + '/contribuicao/get-configs').map((data) => {
      return data;
    });
  }

  getMinhasContribuicoes() {
    return this.http.get<any>(this.baseUrl + '/contribuicao/get-minhas-contribuicoes').map((data) => {
      return data;
    });
  }

  getBoletoParcela(idContaReceberParcela) {
    return this.http
      .post<any>(this.baseUrl + '/contribuicao/criar-boleto-parcela', {
        idContaReceberParcela: idContaReceberParcela,
      })
      .map((data) => {
        return data;
      });
  }

  cancelarPlanoContribuicao(idPlanoContribuicaoPessoa) {
    return this.http
      .post<any>(this.baseUrl + '/contribuicao/cancelar-contribuicao', {
        idPlanoContribuicaoPessoa: idPlanoContribuicaoPessoa,
      })
      .map((data) => {
        return data;
      });
  }

  registrarTokenTemporario() {
    return this.http.get<any>(this.baseUrl + '/contribuicao/registrar-token').map((data) => {
      return data;
    });
  }

  getCartoesPessoa() {
    return this.http.get<any>(this.baseUrl + '/iugu-cartao-pessoa/get-cartoes-pessoa').map((data) => {
      return data;
    });
  }

  alterarCartaoPessoa(payment_id) {
    return this.http
      .post<any>(this.baseUrl + '/iugu-cartao-pessoa/alterar-cartao-pessoa', {
        payment_id: payment_id,
      })
      .map((data) => {
        return data;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/contribuicoes/contribuicoes.ts